<template>
  <div style="height: 600px;">
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">请输入要查询的车辆信息
                            计费标准： 0.35 元/次</span>
    </div>
    <div class="checkCI">
      <Input v-model="carNum" placeholder="请输入车牌号" style="width: 200px;margin-left: 5px"/>
      <Input v-model="ownerName" placeholder="请输入车主姓名" style="width: 200px;margin-left: 5px"/>
      <Input v-model="ownerPhone" placeholder="请输入车主号码（选填）" style="width: 200px;margin-left: 5px"/>
      <Button status="primary" icon="ios-search" style="margin-left: 10px;border-radius: 5px;" @click="commit">搜索</Button>
    </div>
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">查询结果</span>
    </div>
    <div class="resultTwo">{{resultTwo}}</div>
  </div>
</template>
<script>
  import {apiGet} from "../../utils/api";
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    name: 'checkCN',
    data() {
      return {
        carNum: '',
        ownerName: '',
        ownerPhone: '',
        resultTwo: ''
      }
    },
    methods: {
      commit() {
        let self = this;
        //提示填写信息
        if (!this.carNum || !this.ownerName || !this.ownerPhone) {
          this.$XModal.alert({
            message: '请输入完整信息！',
            status: "error",
          });
          return;
        }
        this.$XModal.confirm("请确认信息无误，确认后将付费查询").then((type) => {
          if (type === "confirm") {
            this.checkOwnerByVclNo();
          }
        });
      },
      async checkOwnerByVclNo() {
        let params = {
          method: 'checkOwnerByVclNo',
          params: {
            vno: this.carNum,
            ownerName: this.ownerName,
            ownerPhone: this.ownerPhone
          }
        }
        showLoading();
        let res = await apiGet("api/order/track/", params.method, params.params);
        hideLoading();
        if (res.status === 1) {
          let data = JSON.parse(res.data)
          if (data.result === "yes") {
            this.resultTwo = "验证通过";
          } else if (data.result === "phone") {
            this.resultTwo = "手机号不正确";
          } else if (data.result === "name") {
            this.resultTwo = "车主姓名不正确";
          } else if (data.status === 1006) {
            this.resultTwo = "无结果";
          } else {
            this.resultTwo = data.result;
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : '接口异常',
            status: "error",
          });
        }
      },
    }
  }
</script>
<style scoped>
  .checkCI {
    height: 40%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }

  .resultTwo {
    height: 20%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }
</style>